import React from "react";

const SvgIcnDashboard = props => (
  <svg
    id="icn_dashboard_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>
        {
          ".icn_dashboard_svg__cls-1{fill:#fff}.icn_dashboard_svg__cls-2{fill:#4a4b4c}"
        }
      </style>
    </defs>
    <path
      className="icn_dashboard_svg__cls-1"
      d="M12 5a10 10 0 0 0-9.54 13h19.08A10 10 0 0 0 12 5z"
    />
    <path className="icn_dashboard_svg__cls-2" d="M11 5h2v4h-2z" />
    <path
      className="icn_dashboard_svg__cls-2"
      transform="rotate(45 18.257 10.242)"
      d="M17.26 8.11h2v4.27h-2z"
    />
    <path
      className="icn_dashboard_svg__cls-2"
      transform="rotate(45 6.373 10.88)"
      d="M.54 9.88h11.68v2H.54z"
    />
    <path
      className="icn_dashboard_svg__cls-2"
      d="M3 15a8.8 8.8 0 0 1 .86-3.81l-1.49-1.5A11 11 0 0 0 1 15v3h9v-2H3zM12 4a11 11 0 0 0-7.08 2.59L6.34 8A8.9 8.9 0 0 1 12 6a9 9 0 0 1 9 9v1h-7v2h9v-3A11 11 0 0 0 12 4z"
    />
    <path
      className="icn_dashboard_svg__cls-2"
      d="M12 14a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
    />
    <circle className="icn_dashboard_svg__cls-1" cx={12} cy={17} r={1} />
  </svg>
);

export default SvgIcnDashboard;
